import styled, { css } from 'styled-components';
import { gridSizes, media, textSizes, weights } from 'utils/style';
import SummaryPrice from './SummaryPrice';

const totalContainerStyles = css`
  .total-container {
    display: flex;
    flex-direction: column;

    button {
      width: 100%;
      min-width: inherit;

      ${media.lessThan('extraSmall')`
        font-size: 14px;
        height: inherit;
        padding: ${gridSizes('S')};
        border-radius: 4px;
    `}
    }

    &.collapsable {
      ${media.lessThan('medium')`
      justify-content: flex-end;
      flex-direction: row;
      align-items: center;

    `}
    }
  }
`;

const priceContainerStyles = css`
  .feasibility-message-container {
    margin-top: 3rem;
  }
  .concepts {
    margin-top: ${gridSizes('M')};
  }

  .price-container {
    display: flex;
    width: 100%;
    padding-top: ${gridSizes('M')};
    align-items: baseline;

    &.more-than-one-day-quote {
      display: none;
      ${media.lessThan('medium')`
        display: block;
        flex-direction: column;
        flex: 1;
        align-items: flex-start;
        padding: 0;
    `}
    }

    &.collapsable {
      padding: ${gridSizes('M')} 0;
      ${media.lessThan('medium')`
      flex-direction: column;
      flex: 1;
      align-items: flex-start;
      padding: 0;

    `}
    }
  }

  .price-literal-container {
    order: 1;
    &.collapsable {
      ${media.lessThan('medium')`
      order: 0;
      line-height: normal;
      display: flex;
      align-items: center;
      > div:first-child{
        margin-right: ${gridSizes('S')};
      }
    `}
    }
  }

  .price-literal {
    font-size: ${textSizes('XXL')};
    color: var(--grey900);
    font-weight: ${weights('medium')};
    margin: 0;
    white-space: nowrap;

    &.collapsable {
      ${media.lessThan('extraSmall')`
      /*TODO*/
      font-size: 20px;
    `}
    }
  }

  .vat-literal {
    order: 0;
    flex: 1;
    margin-right: ${gridSizes('M')};
    font-weight: ${weights('medium')};

    &.collapsable {
      ${media.lessThan('medium')`
      order: 1;
      line-height: normal;
      font-weight: ${weights('regular')};
    `}
      ${media.lessThan('extraSmall')`
      font-size: ${textSizes('M')};
    `}
    }
  }
`;

const buttonActionStyles = css`
  ${media.lessThan('medium')`
    .button-container{
      min-width: 260px;
    }
  `};
  ${media.lessThan('small')`
    .button-container{
      min-width: auto;
    }
  `}
  .button-action {
    text-decoration: none;
    outline: none;
    -webkit-appearance: none;
    border: 0;
    cursor: pointer;
    text-transform: uppercase;
    background: var(--primary500);
    color: #fff;
    padding: ${gridSizes('M')};
    /*TODO*/
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    border-radius: ${gridSizes('S')};
    text-align: left;
    ${media.lessThan('extraSmall')`
      font-size: ${textSizes('M')};
      padding: ${gridSizes('S')};
      border-radius: ${gridSizes('XS')};
    `}
  }
  .button-wrapper {
    display: flex;
    align-items: center;
  }
  .button-text {
    white-space: nowrap;
    flex: 1;
  }
  .button-icon {
    flex: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: ${gridSizes('M')};
      height: ${gridSizes('M')};
      fill: #fff;
      margin-left: ${gridSizes('M')};
    }
    ${media.lessThan('extraSmall')`
      display: none;
    `}
  }
`;

const vatValueStyles = css`
  .vat-value {
    font-size: ${gridSizes('M')};
    color: var(--grey700);
    font-weight: ${weights('regular')};
    margin: 0;
    text-align: right;

    ${media.lessThan('medium')`
    text-align: left;
  `};
  }
`;

const fixedStyles = css`
  position: fixed;
`;

export default styled(SummaryPrice)`
  ${totalContainerStyles}
  ${priceContainerStyles}
  ${buttonActionStyles}
  ${vatValueStyles}

  ${(props) => (props.fixed ? fixedStyles : '')}
  min-width: 300px;

  h1 {
    font-size: ${gridSizes('L')};
    color: var(--grey900);
    font-weight: ${weights('medium')};
  }

  .breakdown-collapsed {
    display: none;
    justify-content: space-between;
    ul li:last-child {
      border-bottom: 0;
    }
  }

  .price-clarifications {
    color: var(--grey700);
  }

  ${media.lessThan('medium')`
    width: 100%;
    position: initial;
    max-width: unset;
    .breakdown-not-collapsed{
      display: none;
    }

    .breakdown-collapsed{
      display: block;
    }
  `}
`;
